import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KeyboardService } from '@freelancer/keyboard';
import type { Observable } from 'rxjs';

@Component({
  selector: 'fl-sticky-footer-body',
  template: `
    <div
      class="StickyFooterBody"
      [class.FullHeight]="fullHeight"
      [class.IsKeyboardOpen]="isKeyboardOpen$ | flAsync"
      [class.EdgeToEdge]="edgeToEdge"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./sticky-footer-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyFooterBodyComponent implements OnInit {
  // FIXME: T269657 - Update fl-sticky-footer-body to support setting height
  @Input() fullHeight = false;

  @Input() edgeToEdge = false;

  isKeyboardOpen$: Observable<boolean>;

  constructor(private keyboardService: KeyboardService) {}

  ngOnInit(): void {
    this.isKeyboardOpen$ = this.keyboardService.isOpen();
  }
}
